import React from 'react';
import { Form, Input } from 'antd';
import { formLayout } from '@bluevision/tools';
import { LockOutlined } from '@ant-design/icons';
import type { SimpleFunc } from '@bluevision/tools';
import ToggleRender from '@/components/Render/ToggleRender';
import CEditModalForm from '@/components/CModal/CEditModal/Content';
import ConfirmPassword from '@/components/CForm/ConfirmPassword';
import { modifyPassword } from '@/services/authority/login/login';

const { tailLayout } = formLayout;

type IChangePasswordProps = {
  onClose: SimpleFunc;
  visible?: boolean;
};

const ChangePassword: React.FC<IChangePasswordProps> = ({ visible, onClose }) => (
  <ToggleRender visible={visible}>
    <CEditModalForm
      formProps={tailLayout}
      btnText='修改密码'
      onClose={onClose}
      service={modifyPassword}
    >
      <Form.Item
        label='旧密码'
        name='curPassword'
        rules={[{ required: true, message: '请输入旧密码' }]}
      >
        <Input.Password
          placeholder='请输入'
          prefix={<LockOutlined />}
          autoComplete='new-password'
        />
      </Form.Item>
      <ConfirmPassword />
    </CEditModalForm>
  </ToggleRender>
);
export default ChangePassword;
